
import React from "react";
import { Popup } from "@progress/kendo-react-popup";
import { Icon } from "@iconify/react";
import "./popupmenu.scss";

// interface to declare all our prop types
interface Props {
  children: React.ReactNode;
  icon?: string;
  title?: string;
  popupAlign?:string;
}

const PopupMenu: React.FC<Props> = ({
  children,
  icon,
  title,
  popupAlign = '',
  ...rest
}) => {
  
  const anchor = React.useRef(null);
  const [show, setShow] = React.useState(false);
  React.useEffect(() => {
    setShow(false);
  }, []);

  const onClick = () => {
    setShow(!show);
  };
  
 // document.getElementById('form')?.addEventListener('blur',()=>{setShow(false)},true)
  
  return (

    <div className="popupmenu"> 
        <button
        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
        onClick={onClick}
        ref={anchor}
      >
         {title && <Icon icon={icon ? "fluent:add-circle-20-regular" : ''} color='green'/>}
        <p className="popuptitle"> {title}</p>
        <Icon icon={icon ? icon : "entypo:dots-three-vertical"} color='green' />
       
      </button>
      <Popup anchor={anchor.current} show={show} popupClass={`popup-content ${popupAlign}`}>
        {children}
      </Popup>
    </div>
  );
};

export default PopupMenu;
